const styles = ({ COLORS, BREAKPOINTS }) => ({
  link: {
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none',
    '& svg': {
      margin: '-2px -4px 0 0'
    }
  },
  pupilsList: {
    [`@media (max-width: ${BREAKPOINTS.XS})`]: {
      display: 'none'
    }
  }
})

export default styles
